var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SupplierList"},[_c('div',{staticClass:"row"},_vm._l((_vm.suppliers),function(item){return _c('div',{key:item.id,staticClass:"col-12 col-sm-6 col-md-6 col-lg-4"},[_c('SupplierCard',{attrs:{"supplier":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }